if (!customElements.get('video-review-player')) {
  customElements.define('video-review-player', class VideoReviewPlayer extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.video-review__video');
      this.playButton = this.querySelector('.video-review__play');

      if (!this.video) return;

      this._abort = new AbortController();
      const { signal } = this._abort;

      this.playButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.play();
      }, { signal });

      this.video.addEventListener('click', (event) => {
        event.stopPropagation();
        if (!this.video.paused) this.pause();
      }, { signal });
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._abort = null;
    }

    play() {
      this.pauseOthers();
      this.video.muted = false;
      const playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }

      this.classList.add('is-playing');
    }

    pause() {
      this.video.pause();
      this.classList.remove('is-playing');
    }

    pauseOthers() {
      this.closest('video-reviews')
        ?.querySelectorAll('video-review-player.is-playing')
        .forEach((player) => {
          if (player !== this) player.pause();
        });
    }
  });
}
